import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "cta flex al-center pointer" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = { class: "c-navy bold fira f-menu uppercase wc-lg" }

import {arrowRight} from "./svgs"
import fn from "../../helpers/func"


// PROPS

export default /*#__PURE__*/_defineComponent({
  props: {
    text: {
        type: String,
        default: fn.tr('Explore Now'),
        required: false,
    },
},
  setup(__props) {

/**
 * @author Irakli Kandelaki
 */

// IMPORTS


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "lh-0",
      innerHTML: _unref(arrowRight)
    }, null, 8, _hoisted_2),
    _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.$fn.tr(__props.text)), 1)
  ]))
}
}

})